import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { Transition } from "../../hooks/useConfirm";
import { CrossIcon } from "../../assets/icons";
import { WarningLabelIcon } from "../IconLabel";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface IProps {
  open: boolean;
  close: Function;
}

export default function UserNotFoundDialog(props: IProps) {
  const { t } = useTranslation("dialog");
  const { open, close } = props;

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    close(false);
  };

  return (
    <Dialog
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          width: "100%",
          maxWidth: "360px",
        },
        "& .MuiDialogContent-root,& .MuiDialogActions-root": {
          padding: "48px 24px",
        },
        "& .MuiDialogContent-root": {
          color: "text.fontDarkest",
          fontSize: "14px",
          width: "100%",
          display: "flex",
        },
      }}
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          insetInlineEnd: 8,
          top: 8,
          color: "text.fontDarkest",
          zIndex: 2,
        }}
      >
        <CrossIcon />
      </IconButton>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <WarningLabelIcon />
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              lineHeight: "normal",
              color: "text.warningDark",
              marginTop: "16px",
              textAlign: "center",
            }}
          >
            {t("userNotFoundTitle")}
          </Typography>
          <Box
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "22px",
              color: "text.fontDarkest",
              textAlign: "center",
            }}
          >
            {t("userNotFoundMessage")}
          </Box>
          <Link style={{ textDecoration: "none" }} to={`/join`}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Button fullWidth color="primary" variant="contained" disableElevation>
                {t("joinNow")}
              </Button>
            </Box>
          </Link>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
